
function validateAcceptFile(fileName, acceptFile) {
    const extensionFile = fileName.substr(fileName.lastIndexOf('.') + 1);
    return acceptFile.includes(extensionFile) ? true : false;
}
export default validateAcceptFile;
